import { GET, POST } from "./api.js";

export const casesError = {
    casesErrorsConsult: (data) => GET(`/casesError/${data}`),
}